import BaseCommand from "@/models/api/commands/BaseCommand";
import { ContractorViewModel } from "../ContractorViewModel";

export class ChangeContractorCommand extends BaseCommand {
  CommandName = "ChangeContractor";
  Command: ContractorViewModel;
  constructor(sessionId: string, operationId: string, model: ContractorViewModel) {
    super(sessionId, operationId);
    this.Command = model;
  }
}
